import { MAZE } from '../../constants/measure';
import { RECORDINGS_STORE_NAME, CONTENT_STORE_NAME, RESULTS_STORE_NAME } from './constants';
import { getPersistenceStorages, getStudentResultKey } from './storage';

export const hasPersistedRecording = async key => {
    const storages = getPersistenceStorages();
    if (storages) {
        return (await storages[RECORDINGS_STORE_NAME].getItem(key)) !== null;
    }
    return false;
};

export const hasOfflineResults = async studentUid => {
    const storages = getPersistenceStorages();
    // We set measure for MAZE as a default value.
    // If there would be more measure with offline data support
    // this code will be wrapped into Promise.all to get offline
    // result for each measure per student
    return (
        (await storages[RESULTS_STORE_NAME].getItem(
            getStudentResultKey(studentUid, MAZE.MEASURE),
        )) !== null
    );
};

export const setItemToLocalStorage = (key, value) => localStorage.setItem(key, value);

export const getItemFromLocalStorage = key => localStorage.getItem(key);

export const getOfflineContent = async endpoint => {
    const storages = getPersistenceStorages();
    return storages[CONTENT_STORE_NAME].getItem(endpoint);
};
